import { Link } from "react-router-dom";
import "./Contact.css";

const Contact = () => {
    return (
        <div className="contact-container">
            <div className="contact-overlay"></div>
            <div className="contact-header-container">
                <p className="contact-pre-header">Contact us</p>
                <h1 className="contact-header">Get in touch</h1>
                <p>701-893-6853 | Rkollie3@pmcardetailing.com</p>
            </div>

            <div className="contact-description-container">
                <p className="contact-description">We are here to answer any questions you may have. Reach out to us and we'll respond as soon as we can.</p>
                <Link to='/contact'>
                    <button className="contact-button">Contact us</button>
                </Link>
            </div>
        </div>
    )
}

export default Contact;